<template>
  <div class="form-elements">
    <form @submit.prevent="validateBeforeSubmit">
      <h3>{{ $t('register.personalInfo') }}</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input :name="$t('register.name')" v-model="user.name" :data-vv-name="$t('register.name')" v-validate="'required'" required />
              <label class="control-label">{{ 'register.name' | translate }}*</label><i class="bar"></i>
              <small v-show="errors.has($t('register.name')) && user.name !== null" class="help text-danger">
                {{ errors.first($t('register.name')) }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input :name="$t('register.surname')" v-model="user.surname" :data-vv-name="$t('register.surname')" v-validate="'required'" required />
              <label class="control-label">{{ 'register.surname'
                | translate }}*</label><i class="bar"></i>
              <small v-show="errors.has($t('register.surname')) && user.surname !== null" class="help text-danger">
                {{ errors.first($t('register.surname')) }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group with-icon-right with-icon-left">
            <div class="input-group">
              <input :name="$t('register.email')" :data-vv-name="$t('register.email')" v-model="user.email"
                v-validate="'required|email'" required />
              <i class="fa fa-envelope-o icon-left input-icon"></i>
              <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
              <i class="fa fa-check valid-icon icon-right input-icon"></i>
              <label class="control-label" for="successfulEmail">{{ 'register.email'
                | translate }}* </label><i class="bar"></i>
              <small v-show="errors.has($t('register.email')) && user.email !== null" class="help text-danger">
                {{ errors.first($t('register.email')) }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input :name="$t('register.phone')" v-model="user.phone" :data-vv-name="$t('register.phone')" v-validate="'required|numeric'" type="tel" required />
              <label class="control-label">{{ 'register.phone'
                | translate }}*</label><i class="bar"></i>
              <small v-show="errors.has($t('register.phone')) && user.phone !== null" class="help text-danger">
                {{ errors.first($t('register.phone')) }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input :name="$t('register.company')" v-model="user.company" />
              <label class="control-label">{{ $t('register.company') }} ({{ $t('register.optional') }})</label><i
                class="bar"></i>
            </div>
          </div>
        </div>
      </div>

      <h3>{{ $t('register.address') }}</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input :name="$t('register.address')" v-model="user.address" required />
              <label class="control-label">{{ 'register.address'
                | translate }}*</label><i class="bar"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input :name="$t('register.postcode')" v-model="user.postcode" required />
              <label class="control-label">{{ 'register.postcode'
                | translate }}*</label><i class="bar"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <vuestic-simple-select :label="$t('register.country') + '*'" v-model="user.country"
            v-bind:options="countriesList" option-key="description" :data-vv-name="$t('register.country')"
            v-validate="'isSelectedCustom'" required>
          </vuestic-simple-select>
          <small v-show="errors.has($t('register.country')) && user.country.description !== ''" class="help text-danger">
            {{ errors.first($t('register.country')) }}
          </small>
        </div>

        <div class="col-md-3">
          <!-- if state exists in the json file, show as a select -->
          <template v-if="statesList.length">
            <vuestic-simple-select :label="$t('register.state') + '*'" v-model="user.state"
              :data-vv-name="$t('register.state')" v-validate="'isSelectedCustom'" v-bind:options="statesList"
              option-key="description" class="mb-0" required>
            </vuestic-simple-select>
            <small v-show="errors.has($t('register.state')) && user.state.description == ''" class="help text-danger">
              {{ errors.first($t('register.state')) }}
            </small>
          </template>
          <!-- if state DOES NOT exists in the json file, show as a input field -->
          <div class="form-group mb-0" v-else>
            <div class="input-group">
              <input :name="$t('register.state')" v-model="user.state.description" :data-vv-name="$t('register.state')" v-validate="'required|min:2'"
                required />
              <label class="control-label">{{ 'register.state' | translate }}*</label><i class="bar"></i>
              <small v-show="errors.has($t('register.state')) && user.state.description !== null"
                class="help text-danger">
                {{ errors.first($t('register.state')) }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <div class="input-group">
              <input :name="$t('register.city')" v-model="user.city" :data-vv-name="$t('register.city')" v-validate="'required'" required />
              <label class="control-label">{{ 'register.city' | translate }}*</label><i class="bar"></i>
              <small v-show="errors.has($t('register.city')) && user.city !== null" class="help text-danger">
                {{ errors.first($t('register.city')) }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-md-6">
        </div>

      </div>

      <div v-if="existCustomFields">
        <h3>{{ $t('register.additionalInfo') }}</h3>
        <div class="row">
          <div class="col-md-6" v-for="(field, index) in customFields" :key="index">
            <template v-if="field.name === 'CPF / CNPJ'">
              <div class="form-group">
                <div class="input-group">
                  <input @input="formatCnpjCpf(index)" v-model="field.value" v-validate="'required'" required />
                  <label class="control-label">{{ field.name }}</label><i class="bar"></i>
                  <small v-show="isDocumentError" class="help text-danger">
                    {{ $t('register.cpfcnpj_invalid') }}
                  </small>
                </div>
              </div>
            </template>
            <template v-else-if="field.fieldtype === 'text'">
              <div class="form-group">
                <div class="input-group">
                  <input v-model="field.value" v-validate="'required'" required />
                  <label class="control-label">{{ field.name }}</label><i class="bar"></i>
                  <small v-show="errors.has(field.name) && field.value !== null" class="help text-danger">
                    {{ errors.first(field.name) }}
                  </small>
                </div>
              </div>
            </template>
            <template v-else-if="field.fieldtype === 'dropdown'">
              <vuestic-simple-select :label="field.name" v-model="field.value" v-bind:options="field.fieldoptions" class="mb-0"
                :data-vv-name="field.name" v-validate="'required'">
              </vuestic-simple-select>
              <small v-show="errors.has(field.name)" class="help text-danger">
                {{ errors.first(field.name) }}
              </small>
            </template>
          </div>
        </div>
      </div>

      <h3>{{ $t('register.accountSecurity') }}</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input v-model="password" type="password" required v-validate="'min:6'"
                :data-vv-name="$t('register.password')" />
              <label class="control-label">{{ 'register.password' | translate }}*</label><i class="bar"></i>
              <small v-show="errors.has($t('register.password')) && password !== null" class="help text-danger">
                {{ errors.first($t('register.password')) }}
              </small>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <input v-model="confirmPassword" :data-vv-name="$t('register.confirmPassword')"
                v-validate="{ is: password }" type="password" required />
              <label class="control-label">{{ 'register.confirmPassword' | translate }}*</label><i class="bar"></i>
              <small v-show="errors.has($t('register.confirmPassword')) && confirmPassword !== null"
                class="help text-danger">
                {{ errors.first($t('register.confirmPassword')) }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-md-12">
          <div class="form-group mb-0">
            <vuestic-checkbox :label="'register.agreement' | translate" :isCircle="true" class="mb-0"
              v-model="tosCheckbox" :data-vv-name="$t('register.tos')" v-validate="'required:true'" />
            <a :href="$t('register.tosLink')" target="_blank" class="text-primary d-flex align-items-end"
              style="line-height: 1.2rem">
              &nbsp; {{ $t('register.tos') }}
            </a>
          </div>
          <small v-show="errors.has($t('register.tos')) && tosCheckbox == false" class="help text-danger ml-5">
            {{ errors.first($t('register.tos')) }}
          </small>
        </div>
      </div>


      <div class="col-12" v-if="alert">
        <div class="alert alert-warning mb-0" role="alert">
          {{ $t(alertInfo) }}
        </div>
      </div>

      <div class="text-center" v-if="loadBtn">
        <span class="loader"></span>
      </div>

      <button type="submit" class="btn btn-lg btn-primary btn-block btn-purple" v-else>
        <i class="fa-solid fa-user-plus"></i> {{ $t('register.signup') }}
      </button>
    </form>
  </div>
</template>

<script>
import configs from '@/services/configs'
import { Validator } from 'vee-validate';
import distCountries from 'data/whmcs/dist.countries.json'
import distStates from 'data/whmcs/dist.states.json'
import store from '../../../store'

import { getAxios } from 'services/ajax'

export default {
  name: 'register',
  computed: {
    countryComputed() {
      return this.user.country
    },
    isSuccessfulEmailValid() {
      let isValid = false
      if (this.formFields.successfulEmail) {
        isValid = this.formFields.successfulEmail.validated && this.formFields.successfulEmail.valid
      }
      return isValid
    },
    isConfirmPassword() {
      return !this.confirmPassword !== this.password;
    }
  },
  data() {
    return {
      existCustomFields: false,
      customFields: [],
      alert: false,
      alertInfo: null,
      user: {
        name: null,
        surname: null,
        email: null,
        company: null,
        state: {
          id: '',
          description: ''
        },
        country: {
          id: '',
          description: '',
          callingCode: ''
        },
        city: null,
        address: null,
        postcode: null,
        phone: null,
        document: null
      },
      loadBtn: false,
      countriesList: [],
      statesList: [],
      successfulEmail: 'andrei@masterdaweb.com',
      wrongEmail: 'andrei@masterdaweb',
      password: null,
      confirmPassword: null,
      tosCheckbox: false,
      callbacks: {
        success: null,
        error: null
      },
      isDocumentError: false,
    }
  },
  methods: {
    listCustomFields() {
      store.commit('setLoading', true)

      getAxios().get('customer/user/custom_fields')
        .then(response => {
          this.existCustomFields = true
          this.customFields = response.data.WhmcsRegisterCustomFields.data
        })
        .catch(err => {
        })
        .finally(() => {
          store.commit('setLoading', false)
        });
    },
    validarCPFCNPJ(numero) {
      // Remove caracteres não numéricos
      numero = numero.replace(/\D/g, '');

      // Verifica se o número tem 11 dígitos (CPF)
      if (numero.length === 11) {
        // Algoritmo de validação de CPF
        let soma = 0;
        let resto;
        for (let i = 1; i <= 9; i++) {
          soma += parseInt(numero.charAt(i - 1)) * (11 - i);
        }
        resto = (soma * 10) % 11;

        if (resto === 10 || resto === 11) {
          resto = 0;
        }

        if (resto !== parseInt(numero.charAt(9))) {
          this.isDocumentError = true
          return false;
        }

        soma = 0;
        for (let i = 1; i <= 10; i++) {
          soma += parseInt(numero.charAt(i - 1)) * (12 - i);
        }
        resto = (soma * 10) % 11;

        if (resto === 10 || resto === 11) {
          resto = 0;
        }

        if (resto !== parseInt(numero.charAt(10))) {
          this.isDocumentError = true
          return false;
        }

        this.isDocumentError = false
        return true; // Se for um CPF válido
      }

      // Verifica se o número tem 14 dígitos (CNPJ)
      if (numero.length === 14) {
        // Algoritmo de validação de CNPJ
        let tamanho = numero.length - 2;
        let numeros = numero.substring(0, tamanho);
        const digitos = numero.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
          soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

        if (resultado !== parseInt(digitos.charAt(0))) {
          this.isDocumentError = true
          return false;
        }

        tamanho = tamanho + 1;
        numeros = numero.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
          soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

        if (resultado !== parseInt(digitos.charAt(1))) {
          this.isDocumentError = true
          return false;
        }

        this.isDocumentError = false
        return true; // Se for um CNPJ válido
      }

      // Se não for um CPF nem CNPJ válido
      this.isDocumentError = true
      return false;
    },
    formatCnpjCpf(input) {
      // Remove qualquer caractere que não seja número
      this.customFields[input].value = this.customFields[input].value.replace(/\D/g, '');

      if (!this.validarCPFCNPJ(this.customFields[input].value.replace(/\D/g, ''))) {
        return false
      }

      // Verifica se é CNPJ (14 dígitos) ou CPF (11 dígitos)
      if (this.customFields[input].value.length === 14) {
        this.customFields[input].value = this.customFields[input].value.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
          '$1.$2.$3/$4-$5'
        );
      } else if (this.customFields[input].value.length === 11) {
        this.customFields[input].value = this.customFields[input].value.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          '$1.$2.$3-$4'
        );
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result && this.isDocumentError === false) {
          // eslint-disable-next-line
          this.createAccount()

          return;
        }

        return false;
      });
    },

    clear(field) {
      this[field] = ''
    },

    createAccount() {
      this.loadBtn = true

      const formData = new FormData()

      formData.append('password', this.password)
      formData.append('firstname', this.user.name)
      formData.append('lastname', this.user.surname)
      formData.append('email', this.user.email)
      formData.append('address1', this.user.address)
      formData.append('city', this.user.city)
      formData.append('state', this.user.state.id !== '' ? this.user.state.id : this.user.state.description)
      formData.append('postcode', this.user.postcode)
      formData.append('country', this.user.country.id)
      formData.append('phonenumber', `+${this.user.country.callingCode}.${this.user.phone}`)

      formData.append('custom_fields', JSON.stringify(this.customFields))

      getAxios().post('customer/user/create/client', formData)
        .then(response => {
          this.$emit('updateAuthEvent', response.data.WhmcsCreateUserClient.data)
        })
        .catch(err => {
          this.alert = true
          this.alertInfo = err.response.data.WhmcsCreateUserClient.error
        })
        .finally(() => {
          this.loadBtn = false
        });
    },
  },
  created() {
    this.listCustomFields();

    /*
    this.$nextTick(() => {
      this.$validator.validateAll()
    })
    */

    // Custom validation rule for State and Country select
    Validator.extend('isSelectedCustom', {
      getMessage: field => this.$t('register.invalid_field', { field: field }),
      validate: value => value.description !== ''
    });

    Object.keys(distCountries).forEach((key, index) => {
      this.countriesList.push({
        id: key,
        description: distCountries[key].name,
        callingCode: distCountries[key].callingCode
      })
    })

    // Default to Brasil
    this.user.country = {
      id: 'BR',
      description: 'Brasil',
      callingCode: 55
    }
  },
  watch: {
    countryComputed(value) {
      if (distStates[value.id] !== undefined) {
        // clear up state list and selected state
        this.statesList = distStates[value.id].map((state) => {
          return {
            id: state.code,
            description: state.name
          }
        })
        this.user.state = {
          id: '',
          description: ''
        }
      } else {
        // clear up state list and selected state
        this.statesList = []
        this.user.state = {
          id: '',
          description: ''
        }
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/auth/forms/Register.vue